import axios from "axios";


//const  access_token: "eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJiWmlIdXEzTXdCTFJKeGZ3QXZqeFViZDRJLVlRZTkwUGhUZHotajhWeWowIn0.eyJleHAiOjE3NzkxMDM2NzgsImlhdCI6MTc3OTEwMDA3OCwianRpIjoiYjNmMmQ1NDQtY2QzOC00YzliLWI1YjEtNmRhNTMxNGNjZWRmIiwiaXNzIjoiaHR0cHM6Ly9wb3J0YWwudW1icmVsbGFpb3QuY29tL2F1dGgvcmVhbG1zL1Rlc3QiLCJhdWQiOiJhY2NvdW50Iiwic3ViIjoiZTY0OGVmOGItMzlhMy00NWVjLWI1YzYtOWJlOWUzM2JhOTQwIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoidGVzdCIsImFjciI6IjEiLCJyZWFsbV9hY2Nlc3MiOnsicm9sZXMiOlsib2ZmbGluZV9hY2Nlc3MiLCJ1bWFfYXV0aG9yaXphdGlvbiJdfSwicmVzb3VyY2VfYWNjZXNzIjp7InRlc3QiOnsicm9sZXMiOlsidW1hX3Byb3RlY3Rpb24iXX0sImFjY291bnQiOnsicm9sZXMiOlsibWFuYWdlLWFjY291bnQiLCJtYW5hZ2UtYWNjb3VudC1saW5rcyIsInZpZXctcHJvZmlsZSJdfX0sInNjb3BlIjoiZW1haWwgcHJvZmlsZSIsImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwiY2xpZW50SG9zdCI6IjEwLjUwLjIuNSIsImNsaWVudElkIjoidGVzdCIsInByZWZlcnJlZF91c2VybmFtZSI6InNlcnZpY2UtYWNjb3VudC10ZXN0IiwiY2xpZW50QWRkcmVzcyI6IjEwLjUwLjIuNSJ9.GB_PH8WlKxDXKE8V9R0FoPRPJDcRzTSDxSQjmUBdj0AKs553u58eigpn3BpXxZjetU1SqpbZ3YOBV88s8Mnu8Qr_I_v49rXrJseH_6z2NgRA9VeHYrpMoBXz0n56tdktH4M5hGWx-VS3_doCM6wIu979FQrY1KG1IXPde_LrDRB9HTI14_R9XtyZrJCI2cAPjiEq9gsXZcRlsjmDbeXCoZ5UuZ9I035GywsjGPdrv_bRlzBLeR6gtAcvyd6ENA7yErb66i1KYX90yOhLEOBqOsWJvROUyAJFgUOZYPxHfrKyex5SVWjq9ZbJo_gclBSSg7_S_qWQRZYDQJ7E9KlMuA";


const api = axios.create({
  baseURL: process.env.REACT_APP_DASHBOARD_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token =
    localStorage.getItem("usertoken");

  if (token) {
    config.headers.Authorization =
      `Bearer ${token}`;
  }

  return config;
});

export default api;